<template>
<div ref="star-list-body" class="wiki-start">
        <div v-if="!starWikiList.length" class="wiki-start-empty">
            <div class="tip">{{$t("点击下方知识库右侧#!!!#src/pages/CloudHome/components/starList.vue_1")}}<svg-icon slot="reference" iconClass="cloud-wiki-top-grey" class="start-icon"></svg-icon>{{$t("即可置顶#!!!#src/pages/CloudHome/components/starList.vue_1")}}</div>
        </div>
        <div v-for="item in starWikiList" class="start-item" @click="handleOpenWiki(item, {})">
            <div class="wiki-group">
                <img v-if="item?.wikiSpaceIcon?.imageUrl" class="file-icon wiki-file-icon" :src="item?.wikiSpaceIcon?.imageUrl" alt="">
                <svg-icon v-else iconClass="cloud-wiki" class="file-icon"></svg-icon>
                <div class="wiki-info">
                    <div class="title">
                        <span class="wiki-title">{{ item.wikiSpaceName }}</span>
                        <span v-show="item.visibleScope == 'ORGANIZATION'" class="open-tag">{{$t("公开#!!!#src/pages/CloudHome/components/starList.vue_1")}}</span>
                    </div>
                    <div v-if="item.wikiSpaceDesc" class="desc">{{ item.wikiSpaceDesc }}</div>
                </div>
            </div>
            <moo-popover :close-delay="0" popper-class="wiki-top-popper" placement="top" trigger="hover" :content="item.star
  ? $t('取消置顶#!!!#src/pages/CloudHome/components/starList.vue_1')
  : $t('置顶#!!!#src/pages/CloudHome/components/starList.vue_1')">
                <div slot="reference" @click.stop="handleOpenWiki(item, { property: 'top' })" class="wiki-top">
                    <svg-icon slot="reference" :iconClass="item?.star ? 'cloud-wiki-untop' : 'cloud-wiki-top'" class="top-icon"></svg-icon>
                </div>
            </moo-popover>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    data() {
        return {
            observer: null
        };
    },
    name: 'StarList',
    methods: {
        handleOpenWiki(row, column) {
            this.$emit('handleOpenWiki', row, column);
        }
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect()
        }
    },
    mounted() {
        this.observer = new ResizeObserver(entries => {
            for (let entry of entries) {
                requestAnimationFrame(() => {
                    if (entry.target === this.$refs['star-list-body']) {
                        const width = entry.contentRect.width
                        console.log('宽度变化:', width)

                        const classList = this.$refs['star-list-body'].classList
                        classList.remove('two-columns', 'three-columns', 'four-columns')

                        if(!this.starWikiList.length){
                            return 
                        }
                        if (width < 960) {
                            classList.add('two-columns')
                        } else if (width < 1440) {
                            classList.add('three-columns')
                        } else {
                            classList.add('four-columns')
                        }
                    }
                })
            }
        })

        this.observer.observe(this.$refs['star-list-body'])
    },
    computed: {
        ...mapState({
            spaceId: (state) => state.spaceId,
            userId: (state) => state.userId,
            collapse: (state) => state.collapse,
            tabTitle: (state) => state.tabTitle,
            headerTitle: (state) => state.headerTitle,
            starWikiList: (state) => state.starWikiList,
        }),
    },
};
</script>

<style lang="scss">
.wiki-top-popper {
    min-width: 36px !important;
    padding: 0 8px !important;
    /* margin: 0 !important; */
    margin-bottom: 5px !important;
    line-height: 36px !important;
    text-align: center !important;
    height: 36px !important;
    background: #FFFFFF !important;
    box-shadow: 0 8px 12px 0 #1213171a !important;
    border-radius: 8px !important;

    .popper__arrow {
        display: none !important;
    }
}

.wiki-top {
    width: 24px;
    height: 24px;
    display: none;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    &:hover {
        background: #E7EAEE;
    }
}

.wiki-file-icon {
    border-radius: 6px;
}

.top-icon {
    user-select: none;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

.two-columns {
    grid-template-columns: repeat(2, 1fr);
}

.three-columns {
    grid-template-columns: repeat(3, 1fr);
}

.four-columns {
    grid-template-columns: repeat(4, 1fr);
}

.wiki-start {
    cursor: pointer;
    width: 100%;
    margin-bottom: 16px;
    display: grid;
    grid-row-gap: 12px;
    /* 行间距 */
    grid-column-gap: 12px;
    /* 列间距 */
    /* display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap; */

    .start-item:hover {
        border: 1px solid #5C70FF;

        .wiki-top {
            display: flex;
        }
    }

    .start-item {
        height: 58px;
        background: #FFFFFF;
        border: 1px solid #EFEFF0;
        border-radius: 6px;
        margin-bottom: 12px;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;
        padding: 11px 20px;
        box-sizing: border-box;
        overflow: hidden;

        .wiki-group {
            flex: 1;
            display: flex;
            flex-flow: row;
            align-items: center;
            justify-content: flex-start;
            overflow: hidden;
        }

        .file-icon {
            width: 36px;
            height: 36px;
            border-radius: 6px;
            margin-right: 16px;
        }

        .wiki-info {
            flex:1;
            height: 100%;
            display: flex;
            flex-flow: column;
            align-items: flex-start;
            justify-content: center;
            overflow: hidden;

            .title {
                display: flex;
                flex-flow: row;
                align-items: center;
                justify-content: flex-start;

                .wiki-title {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #222329;
                    white-space: nowrap;
                    /* 防止文本换行 */
                    overflow: hidden;
                    /* 隐藏超出部分 */
                    text-overflow: ellipsis;
                }
            }

            .desc {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 12px;
                color: #A5A7B3;
            }

            .open-tag {
                margin-left: 8px;
                padding: 0 4px;
                height: 18px;
                text-align: center;
                line-height: 18px;
                background: #eef0ff;
                border-radius: 4px;
                font-weight: 500;
                font-size: 10px;
                color: #5c70ff;
            }

            div {
                width: 100%;
                white-space: nowrap;
                /* 防止文本换行 */
                overflow: hidden;
                /* 隐藏超出部分 */
                text-overflow: ellipsis;
                /* 显示省略号 */
            }
        }
    }

    .wiki-start-empty {
        width: 100%;
        min-height: 102px;
        background: #FFFFFF;
        border: 1px dashed #EFEFF0;
        border-radius: 6px;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: center;

        .tip {
            color: #9E9FA8;
            font-weight: 400;

            .star-icon {
                width: 16px;
                height: 16px;
            }
        }
    }
}
</style>
